import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useUserData from "../hooks/useUserData";
import MUIDataTable from "mui-datatables";
import "../css/ImperiumScans.css";
import { alignProperty } from "@mui/material/styles/cssUtils";
import StatusModule from "./StatusModule";

const resourceCategories = {///
  "white": ["Metals", "Baobabs", "Silicon", "Space Oats", "Nuclear Waste"],
  "#40BF00": ["Petroleum", "Vis", "Jelly Beans", "Copper", "Tin", "Silver", "Titanium", "Psion Icicles"],
  "#007FFC": ["Diamond", "Quantumum", "Alien Bacteria", "Enriched Nuclear Material", "Laconia", "Plasma Crystals", "Gold"],
  "#D86D00": ["Energon", "Dark Matter", "Frozen Blob", "Adamantium", "Rubicite", "Platinum", "Ablution Crystals", "Bacta", "Fermium", "Atmospheric Disturbances", "Dunes", "Roosts", "Trobbles", "Astral Worms"],
  "#992cff": ["Thickened Atmosphere", "Stabilized Weather", "Breathtaking Vistas", "Magnetic Miracle", "Biogeneticists Playground"],
  "#FE2712": ["Goop"]
};

const getResourceColor = (resourceName) => {
  const normalizedName = resourceName.trim().toLowerCase();
  for (const [color, resources] of Object.entries(resourceCategories)) {
    if (resources.some(res => res.toLowerCase() === normalizedName)) {
      return color;
    }
  }
  return "white";
};

const ScanDetails = () => {
  const { galaxy } = useParams();
  const navigate = useNavigate();
  const { userData, loading: loadingUser } = useUserData();

  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [techMultiplier, setTechMultiplier] = useState(1);
  const [noBps, setNoBps] = useState(false);
  const [oatsBp, setOatsBp] = useState(false);
  const [drillsBp, setDrillsBp] = useState(false);
  const [tenDrills, setTenDrills] = useState(false);
  const [owningTeam, setOwningTeam] = useState(false);
  const [owningTeamName, setOwningTeamName] = useState(false);

useEffect(() => {
  fetch(`https://imp.slypandainteractive.com/galaxy_details.php?galaxy=${encodeURIComponent(galaxy)}`)
    .then(r => r.json())
    .then(setDetails)
    .catch(err => console.error("Error fetching scan details:", err));
}, [galaxy]);


useEffect(() => {
  fetch("/universe.json")
    .then(r => r.json())
    .then(data => {
      const allGalaxies = Object.values(data.galaxies || {});
      const match = allGalaxies.find(g => g.name === galaxy);
      if (match) setOwningTeam(match.owningTeamID);
      else setLoading(false);
    })
    .catch(err => {
      console.error("Error loading universe.json:", err);
      setLoading(false);
    });
}, [galaxy]);


useEffect(() => {
  if (owningTeam == null || owningTeam == 0)
    {
      setOwningTeamName("Nobody");
      setLoading(false);
    return;
    } 
  
  fetch("/teams.json")
    .then(r => r.json())
    .then(data => {
      const teamArr = Object.values(data.teams || {});
      const team = teamArr.find(t => t.teamID === owningTeam);
      if (team) setOwningTeamName(team.name);
    })
    .catch(err => console.error("Error loading teams.json:", err))
    .finally(() => setLoading(false));
}, [owningTeam]);

  const parseResources = (resourcesStr) => {
    if (!resourcesStr) return [];
    return resourcesStr.split(", ").map((res) => {
      const [name, amount] = res.split(": ");
      return { name, amount: parseInt(amount, 10) };
    });
  };

  const copyToClipboard = async (row) => {
    const data = {
      planetName: row.planet_name,
      resources: parseResources(row.resources),
      techLevels: {
        "Steel Foundry": Math.ceil(Number(row.steel_foundry) * techMultiplier),
        "Sentient Machine Learning": Math.ceil(Number(row.sentient_machine_learning) * techMultiplier),
        "Star Bottling Plant": Math.ceil(Number(row.star_bottling_plant) * techMultiplier),
        "Figurine Workshop": Math.ceil(Number(row.figurine_workshop) * techMultiplier),
        "Giant Space Still": Math.ceil(Number(row.giant_space_still) * techMultiplier),
      },
      techLevelMultiplier: techMultiplier,
      no_bps: noBps ? 1 : 0,
      oats_bp: oatsBp ? 1 : 0,
      drills_bp: drillsBp ? 1 : 0,
      ten_drills: tenDrills ? 1 : 0,
    };

    try {
      const response = await fetch("https://imp.slypandainteractive.com/generate_file.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      const text = await response.text();
      await navigator.clipboard.writeText(text);
      alert("Data copied to clipboard!");
    } catch (err) {
      console.error("Clipboard copy failed:", err);
      alert("Copy failed.");
    }
  };

  const copyToClipboardTeam = async (row) => {
  const data = {
    planetName: row.planet_name,
    resources: parseResources(row.resources),
    techLevels: {
      "Steel Foundry": Math.ceil(Number(row.steel_foundry) * techMultiplier),
      "Sentient Machine Learning": Math.ceil(Number(row.sentient_machine_learning) * techMultiplier),
      "Star Bottling Plant": Math.ceil(Number(row.star_bottling_plant) * techMultiplier),
      "Figurine Workshop": Math.ceil(Number(row.figurine_workshop) * techMultiplier),
      "Giant Space Still": Math.ceil(Number(row.giant_space_still) * techMultiplier),
    },
    techLevelMultiplier: techMultiplier,
    no_bps: noBps ? 1 : 0,
    oats_bp: oatsBp ? 1 : 0,
    drills_bp: drillsBp ? 1 : 0,
    ten_drills: tenDrills ? 1 : 0,

    // 👇 add whatever "team" means for your generator
    mode: "team",
  };

  try {
    const response = await fetch("https://imp.slypandainteractive.com/generate_file.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    const text = await response.text();
    await navigator.clipboard.writeText(text);
    alert("Team data copied to clipboard!");
  } catch (err) {
    console.error("Clipboard copy failed:", err);
    alert("Copy failed.");
  }
};

  const filteredDetails = details;  

  const tableData = filteredDetails.map((row) => [
    row.upload_team && Number(row.upload_team) > 0
      ? <img
          src={`https://www.starsonata.com/images/team_flags/game/${row.upload_team}`}
          alt={`Team ${row.upload_team}`}
          title={`Team ${row.upload_team}`}          
          style={{ maxWidth: "40px", maxHeight: "40px" }}
        />
      : "",
    row.type,
    row.planet_name,
    row.gravity,
    row.temperature,
      row.atmosphere,
    row.suitability,
    row.base_slots,
    Math.ceil(Number(row.steel_foundry) * techMultiplier),
    Math.ceil(Number(row.sentient_machine_learning) * techMultiplier),
    Math.ceil(Number(row.star_bottling_plant) * techMultiplier),
    Math.ceil(Number(row.figurine_workshop) * techMultiplier),
    Math.ceil(Number(row.giant_space_still) * techMultiplier),
    <span>
      {parseResources(row.resources).map((res, i, arr) => (
        <span key={i} style={{ color: getResourceColor(res.name) }}>
          {res.name}: {res.amount}
          {i < arr.length - 1 ? ", " : ""}
        </span>
      ))}
    </span>,
    row.ruins,
    <span style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
  <button className="back-button" onClick={() => copyToClipboard(row)}> Default</button>
  <button className="back-button" onClick={() => copyToClipboardTeam(row)}> Also Default</button>
</span> 
  ]);

  const makeCenteredColumn = (name) => ({
    name,
    options: {
      align: "center",
      setCellProps: () => ({ 
        style: 
        { 
          textAlign: "center", 
          padding:"15px 6px",
        }           
      }),
      align: "center",
      setCellHeaderProps: () => ({
        style: {
          textAlign: "center",
          whiteSpace: "normal",
          wordWrap: "break-word",
          lineHeight: "1.2", 
          padding:"15px 4px",         
        }
      })
    }
  });

  const columns = [

    makeCenteredColumn("Uploader"),    
    makeCenteredColumn("Type"),
    makeCenteredColumn("Planet"),
    makeCenteredColumn("Gravity"),
    makeCenteredColumn("Temperature"),
    makeCenteredColumn("Atmosphere"),
    makeCenteredColumn("%"),
    makeCenteredColumn("Slots"),
    makeCenteredColumn("Girders"),
    makeCenteredColumn("Chatbots"),
    makeCenteredColumn("Fusions"),
    makeCenteredColumn("Figurines"),
    makeCenteredColumn("Whisky"),
    makeCenteredColumn("Resources"),
    makeCenteredColumn("Ruins"),
    makeCenteredColumn("Preset Trade Bay")
  ];

  const options = {
    selectableRows: "none",
    responsive: "standard",
    rowsPerPage: 50,
    elevation: 0,
    sortOrder: {
      name: "Planet Name",
      direction: "asc"
    },
    setRowProps: () => ({ className: "custom-table-cell" }),
    setTableProps: () => ({ className: "custom-table-root" }),
    setCellProps: () => ({
      style: {
        textAlign: "center",
        padding: "4px 3px"
      }
    }),
    setCellHeaderProps: () => ({
      style: {
        textAlign: "center",
        padding: "6px",
        whiteSpace: "normal",
        wordWrap: "break-word",
        lineHeight: "1.2"
      }
    }),
    textLabels: {
      body: {
        noMatch: "No scan data found."
      }
    }
  };

  return (
    <div className="scan-details imperium-scans">
      <h1 style={{ marginBottom: '0.25rem' }}><img src={`https://www.starsonata.com/images/team_flags/game/${owningTeam}`}></img>  {galaxy} <img src={`https://www.starsonata.com/images/team_flags/game/${owningTeam}`}></img> </h1>
      <p style={{ marginTop: 0 }}><i>Owned by {owningTeamName}</i> </p> 


      <div className="blueprint-options" style={{ margin: "20px 0", textAlign: "center" }}>
        <label><input type="radio" name="techMultiplier" value="0.5" checked={techMultiplier === 0.5} onChange={(e) => setTechMultiplier(parseFloat(e.target.value))} /> Tech 9</label>
        <label><input type="radio" name="techMultiplier" value="1" checked={techMultiplier === 1} onChange={(e) => setTechMultiplier(parseFloat(e.target.value))} /> Tech 16</label>
        <label><input type="radio" name="techMultiplier" value="1.5" checked={techMultiplier === 1.5} onChange={(e) => setTechMultiplier(parseFloat(e.target.value))} /> Tech 20</label>
      </div>

      <div className="blueprint-options" style={{ display: "flex", justifyContent: "center", gap: "20px", marginBottom: "20px" }}>
        <label><input type="checkbox" checked={noBps} onChange={(e) => setNoBps(e.target.checked)} /> No BPs</label>
        <label><input type="checkbox" checked={oatsBp} onChange={(e) => setOatsBp(e.target.checked)} /> Oats BP</label>
        <label><input type="checkbox" checked={drillsBp} onChange={(e) => setDrillsBp(e.target.checked)} /> Drills BP</label>
        <label><input type="checkbox" checked={tenDrills} onChange={(e) => setTenDrills(e.target.checked)} /> +10 Drills</label>
      </div>

      <div className="back-button-container" style={{ marginTop: "20px", textAlign: "center", marginBottom: "20px" }}>
      <StatusModule></StatusModule>
        <button className="back-button" onClick={() => navigate("/starsonata/team/scans")}>Back</button>
      </div>  

      {loading || loadingUser ? (
        <p>Loading scan details...</p>
      ) : (
        <div style={{ maxWidth: "96%", margin: "0 auto"}}>
        <MUIDataTable title={null} data={tableData} columns={columns} options={options}
        />
        </div>
      )}
      
      </div>

  );
};

export default ScanDetails;
